import { ITEMS_PER_PAGE } from '../../constants/navigation';
import { InvalidDataError } from '../../errors/shared';
import { parseString, parseStringArray } from './parsers';
import {
  FilterProblemsArgs,
  ProblemClientData,
  SearchParams,
  SearchParamsArray
} from './search-params';

export const toSearchParams = (object: unknown): SearchParams => {
  if (!object || typeof object !== 'object') {
    throw new Error(
      `Некорректный формат данных: ожидался object, получен ${typeof object}`
    );
  }

  for (const key in object) {
    if (!SearchParamsArray.includes(key)) throw new InvalidDataError();
  }

  let result: SearchParams = {};

  if ('query' in object)
    result = { ...result, query: parseString(object.query) };
  if ('levels' in object)
    result = { ...result, levels: parseStringArray(object.levels) };

  if ('page' in object) result = { ...result, page: parseString(object.page) };

  return result;
};

export function toFilterProblemsArgs(
  searchParams: SearchParams,
  topicId: number
): FilterProblemsArgs {
  const { page, ...rest } = searchParams;

  const offset = page
    ? (parseInt(page, ITEMS_PER_PAGE) - 1) * ITEMS_PER_PAGE
    : undefined;

  return {
    ...rest,
    topicId,
    offset
  };
}

export function toProblemClientData(
  searchParams: SearchParams,
  topicId: number,
  totalPagesCount: number
): ProblemClientData {
  return {
    ...searchParams,
    topicId,
    totalPagesCount
  };
}

export const toSearchParamsString = (params: SearchParams): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(item => searchParams.append(key, item));
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
};
